import { defineMessages } from "react-intl";

export const messages = defineMessages({
  error: {
    id: "fileList.error",
    defaultMessage: "Something went wrong",
    description: "Error message when fails to load files",
  },
});
